module.exports = __webpack_public_path__ + "img/icon-sb-high-alert-color-80.94178f3.svg";